<template>
    <section>
        <div class="row mx-0 p-3 border-bottom">
            <div class="col-auto">
                <p class="f-18 text-general f-600">
                    Usar catálogo de CEDIS diferente
                </p>
            </div>
        </div>
        <div class="custom-scroll overflow-auto" style="height:calc(100vh - 167px)">
            <div class="row mx-0 my-4 py-2">
                <div class="col-auto" />
                <div class="col px-0 text-general f-15">
                    Indique si usará el catalogo de un CEDIS diferente y cual será
                </div>
            </div>
            <div v-for="(cedi,index) in datos" :key="index" class="mx-0 mb-4">
                <div class="row mx-0">
                    <div class="col-3" />
                    <div class="col-1">
                        <p class="f-12 text-general text-center">
                            Catálogo propio
                        </p>
                    </div>
                    <div class="col-4">
                        <p class="f-12 text-general py-2">Seleccionar cedis</p>
                    </div>
                </div>
                <div class="row d-middle mx-0">
                    <div class="col-3 f-15 text-general f-500">
                        {{ cedi.nombre }}
                        <i v-show="!cedi.estado" class="icon-eye-off" />
                    </div>
                    <el-checkbox v-model="cedi.activo" class="col-1 check-dark text-center" @change="onChange(cedi.id,idCatalogo,cedi.activo)" />
                    <div class="col-4">
                        <el-select v-model="cedi.id_cedis_catalogo" placeholder="Seleccionar" size="small" class="w-100" :disabled="cedi.activo" @change="onChange(cedi.id,cedi.id_cedis_catalogo)">
                            <el-option
                            v-for="(cedis,ind) in datos"
                            :key="ind"
                            :label="cedis.nombre"
                            :value="cedis.id"
                            />
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import cedisCatalogoDiferente from '~/services/configurar/admin/cedisCatalogoDiferente'
export default {
    data(){
        return {
            datos: [],
            idCatalogo: null
        }
    },
    mounted(){
        this.listarCedis();
    },
    methods: {
        async listarCedis(){
            try {
                const { data } = await cedisCatalogoDiferente.getCedis();
                this.datos = data
                this.datos = this.datos.map(el=> ({...el, activo: el.id_cedis_catalogo? false : true}))
            } catch (e){
                this.error_catch(e)
            }
        },
        async onChange(idCedis,idCatalogo,activo){
            try {
                let params = {
                    id: idCatalogo ? idCatalogo : null
                }
                const { data } = await cedisCatalogoDiferente.putCedisCatalogo(idCedis,params)
                if(activo){
                    let cedis = this.datos.find(el=> el.id == idCedis)
                    cedis.id_cedis_catalogo = null
                    this.notificacion("","Catálogo actualizado correctamente","success")
                }else if(idCatalogo){
                    this.notificacion("","Catálogo actualizado correctamente","success")
                }
            } catch (e){
                this.error_catch(e)
            }
            
        }
    }
}
</script>